enum DecommissionStatus {
  PROVISIONING = "PROVISIONING",
  ACTIVATED = "ACTIVATED",
  PRE_DECOMMISSIONING = "PRE_DECOMISSIONING",
  DECOMMISSIONED = "DECOMISSIONED"
}

export default DecommissionStatus;
